module.exports = __webpack_public_path__ + "img/justify.5a64a51c.svg";